import axios from 'axios';
export default class ProductCategoryService {


    async getProductCategoryList(first_category, second_category, third_category, productCategoryStatus) {
        return await axios
            .get(`/product-category`, {
                first_category: first_category,
                second_category: second_category,
                third_category: third_category,
                status: productCategoryStatus,
            })
            .then((res) => res.data.data);
    }
    

    async getproductCategoryDropdown() {
        return await axios
            .get(`/product-category`,{})
            .then((res) => res.data.data);
    }

    async getExcel(first_category, second_category, third_category, productCategoryStatus) {
        return await axios({
            url: `/product-category/download`,
            method: 'GET',
            responseType: 'blob', // important
            data: {
                first_category: first_category,
                second_category: second_category,
                third_category: third_category,
                status: productCategoryStatus,
                
            },
        }).then((res) => res);
    }


    async createProductCategory(first_category, second_category, third_category) {
        return await axios
            .post(`/product-category`, {
                first_category: first_category,
                second_category: second_category,
                third_category: third_category,
                
                
            })
            .then((res) => res.data);
    }

    async updateProductCategory(ids,first_category, second_category, third_category, status) {
        return await axios
            .patch(`/product-category/${ids}`, {
                first_category: first_category,
                second_category: second_category,
                third_category: third_category,
                status:status,
            })
            .then((res) => res.data);
    }

    async productCategoryDetails(ids) {
        return await axios
            .get(`/product-category/${ids}`)
            .then((res) => res.data.data);
    }
}
